/**
 * Module rows inside a course that has been opened but not yet loaded.
 *
 * Three rows because that is the low end of what a GSA course holds, so the
 * accordion grows rather than shrinking when the real list arrives.
 */
export const ModuleListSkeleton = () => (
  <div className="flex flex-col divide-y divide-border-secondary">
    {[0, 1, 2].map((row) => (
      <div key={row} className="flex items-center gap-3 py-3">
        <div className="h-3 w-4 shrink-0 animate-pulse rounded bg-muted" />
        <div className="h-3 w-full max-w-[14rem] animate-pulse rounded bg-muted" />
        <div className="ml-auto h-3 w-20 shrink-0 animate-pulse rounded bg-muted" />
      </div>
    ))}
  </div>
);
